export default {
  SET_COMMENT(state, comments) {
    state.comments = comments
  },
  SET_COMMENT_COUNT(state, count) {
    state.commentsCount = count
  },
  REMOVE_RECORD(state, itemId) {
    const commentIndex = state.comments.findIndex(u => u.id === itemId)
    state.comments.splice(commentIndex, 1)
  }
}
